<template>
  <PaginationWrapper
    :page="page"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <AlarmsSearchOptions @onSearch="handleSearch" slot="search-options" :modules=true />
    <AlarmsTable slot="table" />
  </PaginationWrapper>
</template>
<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import AlarmsTable from '@/components/sections/alarms/AlarmsTable';
import AlarmsSearchOptions from '@/components/sections/alarms/AlarmsSearchOptions';

export default {
  name: 'AlarmsList',
  components: {
    PaginationWrapper,
    AlarmsTable,
    AlarmsSearchOptions,
  },
  data() {
    return {
      query: {},
      page: 1,
      totalCount: 0,
      downloading: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      this.totalCount = await this.$store.dispatch('storeAlarms', {
        query: this.query,
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: this.query,
          type: 'alarms',
          subType: 'alarms',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'alarms' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `alarms-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'alarms' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'alarms' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
